import type {DSConfig} from '@wix/document-services-types'

export const isHeadless = (dsConfig: Pick<DSConfig, 'origin'>) =>
    dsConfig.origin === 'DMMigrator' || dsConfig.origin === 'DMMigratorX'
